// extracted by mini-css-extract-plugin
export var equalColumn = "_ge-0";